import { Badge } from '@mantine/core';

import type { ArenaRunStatus } from '../hooks/useModelArena';

const STATUS_COLOUR: Record<ArenaRunStatus, string> = {
  QUEUED: 'gray',
  RUNNING: 'blue',
  COMPLETED: 'green',
  FAILED: 'red',
  CANCELLED: 'gray',
};

/** A run's status, in the same colour wherever it is shown. */
export function StatusBadge({ status, w }: { status: ArenaRunStatus; w?: number }) {
  return (
    <Badge size="sm" color={STATUS_COLOUR[status]} variant="light" w={w}>
      {status.toLowerCase()}
    </Badge>
  );
}
